<template>
    <modal :title="$t(title)" :visible.sync="isShowDialog" width="600px">
        <div class="contentTree">
            <div class="zuzhiClass">
                <span>{{ $t('integration.accessible_organization') }}</span>
                <div class="content">
                    <el-tree :data="structureTree" :props="defaultProps" :render-content="renderContents"></el-tree>
                    <!-- <trees :treedata="structureTree" :defaultProps="defaultProps"></trees> -->
                </div>
            </div>
            <div class="resoureTree">
                <span>{{ $t('integration.operable_resources') }}</span>
                <div class="content">
                    <el-tree :data="sourseTree" :props="defaultProps" :render-content="renderContent"></el-tree>
                </div>
            </div>
        </div>
        <div slot="footer">
            <el-button type="primary" @click="isShowDialog = false">{{ $t('public.btn_close') }}</el-button>
        </div>
    </modal>
</template>

<script>
import { generateTitle } from '@/utils/i18n'

export default {
    props: ['isShow', 'title', 'sourseTree', 'structureTree'],
    computed: {
        isShowDialog: {
            get: function() {
                return this.isShow;
            },
            set: function(val) {
                this.$emit('update:isShow', val); //可以优化成model  或者minx
            }
        }
    },
    data() {
        return {
            defaultProps: {
                label: 'label',
                children: 'item'
            }
        };
    },
    methods: {
        generateTitle,
        iconFn(data) {
            if (data.level === 0) return 'iconfont icon-kehu';
            //nodeType==2时funcType（0-什么都不关联、1-平面图、2-地图）
            else if (data.nodeType === 2) {
                switch (data.funcType) {
                    case 0: {
                        return 'iconfont icon-zuzhijiagou';
                    }
                    case 1: {
                        return 'el-icon-picture';
                    }
                    case 2: {
                        return 'iconfont icon-ditu';
                    }
                    default:
                        break;
                }
            } else if (data.nodeType === 1) {
                return 'el-icon-wallet';
            }
        },
        renderContents(h, { node, data, store }) {
            return (
                <div class="custom-tree-node" style="width:100%;padding-right:15px">
                    <i class={this.iconFn(data)}></i>
                    <span style="margin-left:5px">{node.label}</span>
                </div>
            );
        },
        renderContent() {
            let createElement = arguments[0];
            // 直接使用菜单自带的中/英文名，不再用 i18n key 转换
            return createElement('span', this.generateTitle(arguments[1].data));
        }
    }
};
</script>

<style lang="scss" scoped>
.contentTree {
    height: 400px;
    width: 100%;
    display: flex;
    margin-top: 10px;

    .zuzhiClass,
    .resoureTree {
        flex: 1;
    }

    .resoureTree {
        margin-left: 15px;
    }

    .content {
        padding: 15px;
        box-sizing: border-box;
        border: 1px solid var(--primary-color);
        height: 376px;
        margin-top: 10px;
        overflow: auto;
    }
}
</style>
